import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from 'admin/@fuse/services/config.service';
import { FusePerfectScrollbarDirective } from 'admin/@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { AppService } from 'admin/appModel/appService';


//import { navigation } from 'admin/user/app/navigation';

@Component({
    selector     : 'vertical-layout-1',
    template: require('./layout-1.component.html'),
    styles: [require('./layout-1.component.scss')],
    encapsulation: ViewEncapsulation.None
})
export class VerticalLayout1Component implements OnInit, OnDestroy
{
    @ViewChild('scrollbar', { static: true })
    scrollbar: FusePerfectScrollbarDirective;

    fuseConfig: any;
    navigation: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private appService: AppService,
        private _fuseConfigService: FuseConfigService
    )
    {
        // Set the defaults
        this.navigation = _fuseConfigService.navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    private isLocked: boolean = false;

    private onLockedChanged(isLocked: boolean): void {
        this.isLocked = isLocked;
    }

    private menuIsHidden: boolean = false;

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    
    /**
     * On init
     */
    ngOnInit(): void
    {
        const self = this;

        this.appService.onSetSidebarHidden
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((hidden) => {
                if (hidden == undefined) return;
                setTimeout(() => {
                    self.menuIsHidden = hidden;
                }, 1);
                
            });

        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
            });

        this.appService.scrollbar = this.scrollbar;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
